<script setup lang="ts">
import { AppRawButton } from '@libs/ui';

import type { FlightProductCardData } from '../../../models';

import FlightProductCardContent from './FlightProductCardContent.vue';

interface FlightProductCardProps {
  productCardData: FlightProductCardData;
  printMode: boolean;
}

const props = defineProps<FlightProductCardProps>();

interface FlightProductCardEmits {
  (event: 'show-details'): void;
}

const emit = defineEmits<FlightProductCardEmits>();

function showDetails(): void {
  if (!props.printMode) {
    emit('show-details');
  }
}

function showDetailsOnCardClick(): void {
  showDetails();
}
</script>

<template>
  <AppRawButton
    class="flight-product-card"
    :class="{
      'print-mode': props.printMode,
    }"
    @click="showDetailsOnCardClick"
  >
    <FlightProductCardContent
      :product-card-content="props.productCardData"
      :print-mode="props.printMode"
      @show-details="showDetails"
    />
  </AppRawButton>
</template>

<style scoped lang="scss">
.flight-product-card {
  background: var(--color-white);
  border: 1px solid var(--color-neutral-30);
  border-radius: var(--border-radius-8);
  overflow: hidden;

  &:not(.print-mode) {
    @include on-hover {
      background: var(--color-neutral-30);
      transition: background var(--transition-short);
      cursor: pointer;
    }
  }
}
</style>
